import { Head } from '@inertiajs/react'
import BackstageNav from '@/components/backstage/BackstageNav'

type Lead = {
  id: number
  email: string
  brewery_name: string | null
  keg_count: number | null
  source: string | null
  created_at: string
}

export default function BackstageLeadsIndex({ leads }: { leads: Lead[] }) {
  return (
    <>
      <Head title="Leads - Backstage" />

      <div className="min-h-screen bg-gray-50 font-body">
        <BackstageNav current="leads" />

        <div className="max-w-5xl mx-auto px-6 py-12">
          {/* Le lien « ← Backstage » a été retiré : la navbar porte le retour. */}
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Leads ({leads.length})</h1>

          {leads.length === 0 ? (
            <div className="rounded-xl bg-white border border-gray-200 p-12 text-center">
              <p className="text-gray-500">Aucun lead pour l'instant.</p>
            </div>
          ) : (
            <div className="rounded-xl bg-white border border-gray-200 overflow-hidden">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
                    <th className="px-4 py-3 text-left font-medium">Email</th>
                    <th className="px-4 py-3 text-left font-medium">Brasserie</th>
                    <th className="px-4 py-3 text-right font-medium">Fûts</th>
                    <th className="px-4 py-3 text-left font-medium">Source</th>
                    <th className="px-4 py-3 text-right font-medium">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead) => (
                    <tr key={lead.id} className="border-t border-gray-100">
                      <td className="px-4 py-3 font-medium text-gray-900">{lead.email}</td>
                      <td className="px-4 py-3 text-gray-600">{lead.brewery_name || '—'}</td>
                      <td className="px-4 py-3 text-right text-gray-600">{lead.keg_count || '—'}</td>
                      <td className="px-4 py-3">
                        <span className="inline-flex text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                          {lead.source || '—'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-right text-gray-500">
                        {new Date(lead.created_at).toLocaleDateString('fr-FR', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
